import { State } from 'model/State';

export default (state: State) => state.cart.payload.ifSuccess((cart) => (cart || {}).uuid);
